<template>
  <div class="app-tag" :style="{background: bgColor}" :class="classes">
    <slot />
  </div>
</template>

<script>
  export default {
    name: "AppTag",
    props: {
      color: {
        default: 'primary'
      },
      size: {}
    },
    computed: {
      bgColor(){
        if(['success', 'danger', 'primary', 'warning', 'info'].includes(this.color)){
          return `rgba(var(--app-${this.color}), 1)`;
        }
        else{
          return this.color;
        }
      },
      classes(){
        let classes = [];

        if(this.size){
          classes.push(`app-tag_${this.size}`);
        }

        return classes;
      }
    }
  }
</script>

<style lang="scss">
.app-tag{
  display: inline-block;
  padding: .375em 1em;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 10rem;
  font-weight: 400;
  color: #fff;
  font-size: 90%;

  &_big{
    font-size: 100%;
  }
}
</style>